import { FC, useState, useEffect, ChangeEvent } from 'react';

import { useUpdateWalletModeMutation } from '@entities/wallets';
import { Switch } from '@mui/material';
import { FormItemWithError } from '@shared/components/Form';

interface IProps {
  id: string;
  refetch: () => void;
  isClickhouse?: boolean;
  parserMode: string;
}

export const ParserModeToggler: FC<IProps> = ({ id, parserMode, refetch }) => {
  const [updateWalletMode, { error, isError, isLoading, isSuccess }] =
    useUpdateWalletModeMutation();

  const [localValue, setLocalValue] = useState<string | null>(parserMode);
  const [pendingValue, setPendingValue] = useState<string | null>(null);

  useEffect(() => {
    if (pendingValue === null) {
      setLocalValue(parserMode);
    }
  }, [parserMode, pendingValue]);

  useEffect(() => {
    if (isSuccess && pendingValue !== null) {
      setLocalValue(pendingValue);
      setPendingValue(null);
      refetch();
    }
  }, [isSuccess, pendingValue, refetch]);

  useEffect(() => {
    if (isError && pendingValue !== null) {
      setPendingValue(null);
    }
  }, [isError, pendingValue]);

  const handleChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const newValue = checked ? 'auto' : 'off';

    setPendingValue(newValue);
    updateWalletMode({ id, mode: newValue }).unwrap();
  };

  return (
    <FormItemWithError name={'mode'} error={error} isError={isError}>
      <Switch
        checked={localValue === 'auto'}
        onChange={handleChange}
        disabled={isLoading || pendingValue !== null}
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--accent)' },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'var(--accent)',
          },
        }}
      />
    </FormItemWithError>
  );
};
